import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Breadcrumbs, Typography, Tooltip, Fab } from '@mui/material';
import { Send as SendIcon } from '@mui/icons-material';
import Layout from '@components/Layout';
import SendoutTable from '@components/sendout/SendoutTable';
import SendoutCreationDialog from '@components/sendout/SendoutCreationDialog';

function SendoutListPage() {
    const { t } = useTranslation();
    const [modalCreateOpen, setModalCreateOpen] = useState(false);

    return (
        <Layout withFloatingButton={true}>
            <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
                <Typography>{t('Sendout tracking')}</Typography>
            </Breadcrumbs>

            <SendoutTable />

            <Tooltip title={t('Start a new sendout')} 
                placement="top" arrow>
                <Fab color="primary" aria-label={t('Start a new sendout')}
                    className="main-fab" sx={{ boxShadow: 6 }}
                    onClick={() => setModalCreateOpen(true)}>
                    <SendIcon />
                </Fab>
            </Tooltip>

            <SendoutCreationDialog modalCreateOpen={modalCreateOpen} setModalCreateOpen={setModalCreateOpen} />
            
        </Layout >
    );
}

export default SendoutListPage;
